<template>
  <div>
    <div class="container">
      <Breadcrumbs />
      <!-- Botón Guardar Cambios -->
      <div class="row">
        <div class ="col-md-12">
          <q-btn
            data-cy="bSaveIndiceTematico"
            unelevated
            @click="save()"
            class="bPrincipal"
            :icon="'img:' + require('@/assets/img/save.svg')"
            label="GUARDAR CAMBIOS"
            :loading="isLoadingSave"
          />
        </div>
      </div>
      <!-- Contenedor datos índice temático -->
      <div class="row col-12">
        <div class="col-12">
          <EdicionIndiceTematico  :indiceTematico="dataIndiceTematico"/>
        </div>
      </div>
      <!-- Título Indicadores de Índices Temáticos -->
      <div class="row dLast">
        <ListadoIndicadores
          title="Indicadores"
          titleclass="titleCardEdicion"
          class="col-12"
          :indicadoresSelected="dataIndiceTematico ? dataIndiceTematico.indicadores : []"
          @refreshSelectedItems="refreshSelectedIndicadores"
          showSelection
        />
      </div>
    </div>
  </div>
</template>

<script>
import EdicionIndiceTematico from '../components/EdicionIndiceTematico.vue';
import ListadoIndicadores from '@/components/Indicadores/components/AdminListado.vue';
import Loading from '@/components/shared/mixins/Loading.js';
import * as types from '@/storeModules/NGUD/types';
import { mapGetters } from 'vuex';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';

export default {
  components: {
    EdicionIndiceTematico,
    ListadoIndicadores,
    Breadcrumbs
  },
  mixins: [Loading],
  data () {
    return {
      isNew: true,
      dataIndiceTematico: null,
      selectedIndicadores: [],
      isLoadingSave: false
    };
  },
  computed: {
    ...mapGetters({
      indiceTematico: types.INDICE_TEMATICO
    }),
    name: function () {
      return this.indiceTematico && this.indiceTematico.name ? this.indiceTematico.name.toUpperCase() : '';
    }
  },
  created () {
    this.isNew = true;
    if (this.$route.params.idIndiceTematico) {
      this.showLoading();
      this.isNew = false;
      this.$store.dispatch(types.ACTION_GET_INDICE_TEMATICO, { idIndiceTematico: this.$route.params.idIndiceTematico })
        .then(response => {
          this.dataIndiceTematico = this.indiceTematico;
          this.selectedIndicadores = this.indiceTematico.indicadores;
          this.hideLoading();
        })
        .catch(() => { this.hideLoading(); });
    } else {
      this.dataIndiceTematico = null;
    }
  },
  methods: {
    save () {
      this.$eventHub.$emit('SAVE_INDICE_TEMATICO', {
        callback: (data) => {
          this.isLoadingSave = true;
          if (this.isNew) {
            this.saveNew(data, this.selectedIndicadores);
          } else {
            this.saveUpdate(data, this.selectedIndicadores);
          }
        },
        reject: () => {}
      });
    },
    saveNew (data, arrayIndicadores) {
      this.showLoading();
      let dataToSave = {
        name: data.name.trim(),
        order: data.order,
        visible: data.visible,
        file: data.file,
        indicadores: arrayIndicadores
      };
      this.$store.dispatch(types.ACTION_SAVE_NEW_INDICE_TEMATICO, { newIndiceTematico: dataToSave })
        .then(response => {
          this.$router.push({ name: 'admin_indicestematicos' });
        })
        .catch()
        .finally(() => {
          this.hideLoading();
          this.isLoadingSave = false;
        });
    },
    saveUpdate (data, arrayIndicadores) {
      this.showLoading();
      let dataToSave = {
        name: data.name.trim(),
        order: data.order,
        visible: data.visible,
        file: data.file,
        indicadores: arrayIndicadores
      };

      this.$store.dispatch(types.ACTION_SAVE_INDICE_TEMATICO, {
        newIndiceTematico: dataToSave,
        idIndiceTematico: this.indiceTematico.id
      })
        .then(response => {
          this.$router.push({ name: 'admin_indicestematicos' });
        })
        .catch()
        .finally(() => {
          this.hideLoading();
          this.isLoadingSave = false;
        });
    },
    refreshSelectedIndicadores (indicadores) {
      this.selectedIndicadores = indicadores.selected.map(x => x.id);
    }
  }
};
</script>

<style lang="scss" scoped>
  .bPrincipal {
    margin-bottom: 15px;
    float: right;
  }
  .dBtn {
    margin-bottom: 15px;
  }
  .dLast{
    margin-top: 25px;
  }
</style>
